import { Stack } from "@fluentui/react/lib/Stack";

import { RelevanceActionButton } from "Components/Details/RelevanceActionButton";
import { IContactActionsProps } from "./IContactActionsProps";

export function ContactActions(props: IContactActionsProps): JSX.Element {
  const { contact } = props;

  return (
    <Stack horizontal>
      <Stack.Item grow={false}>
        <RelevanceActionButton item={contact} />
      </Stack.Item>
      <Stack.Item grow disableShrink>
        <div />
      </Stack.Item>
    </Stack>
  );
}
